<button type="button" class="date-range-trigger" [attr.aria-expanded]="isOpen" (click)="toggle()">
  <img src="assets/svg/calendar.svg" width="24" height="24" loading="lazy" alt="Calendar Icon"/>
  <span>{{ label }}</span>
  <i *ngIf="fromDate" class="ri-close-line date-range-clear" role="button" aria-label="Xoá ngày"
    (click)="clear($event)"></i>
</button>
<div class="date-range-popup" [class.open]="isOpen">
  <ngb-datepicker class="date-range-datepicker" [displayMonths]="1" [dayTemplate]="t" outsideDays="hidden" [startDate]="startDate">
  </ngb-datepicker>
</div>
<ng-template #t let-date let-focused="focused">
  <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)" [class.faded]="isHovered(date) || isInside(date)"
    (click)="onDateSelection(date)" (mouseenter)="hoveredDate = date" (mouseleave)="hoveredDate = null">
    {{ date.day }}
  </span>
</ng-template>
